<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import ToolCard from 'dashboard/components-next/captain/assistant/ToolCard.vue';
import FeatureSpotlight from 'dashboard/components-next/feature-spotlight/FeatureSpotlight.vue';

const emit = defineEmits(['click']);

const onClick = () => {
  emit('click');
};

// Sample tools for empty state preview
const sampleTools = [
  {
    id: 1,
    name: 'get_weather',
    title: 'Get Weather Information',
    description:
      'Fetches current weather for any city. Use when user asks about weather, temperature, or forecast.',
    assistant: { name: 'Customer Support Assistant' },
    api_spec: { method: 'GET' },
    enabled: true,
    created_at: Date.now() / 1000,
  },
  {
    id: 2,
    name: 'search_products',
    title: 'Search Products',
    description:
      'Searches product catalog by keywords, categories, or filters. Returns matching products with details.',
    assistant: { name: 'Sales Assistant' },
    api_spec: { method: 'POST' },
    enabled: true,
    created_at: Date.now() / 1000,
  },
];
</script>

<template>
  <FeatureSpotlight
    :title="$t('CAPTAIN.TOOLS.EMPTY_STATE.FEATURE_SPOTLIGHT.TITLE')"
    :note="$t('CAPTAIN.TOOLS.EMPTY_STATE.FEATURE_SPOTLIGHT.NOTE')"
    fallback-thumbnail="/assets/images/dashboard/captain/assistant-light.svg"
    fallback-thumbnail-dark="/assets/images/dashboard/captain/assistant-dark.svg"
    learn-more-url="https://app.vowchat.ai/hc/"
    class="mb-8"
  />
  <EmptyStateLayout
    :title="$t('CAPTAIN.TOOLS.EMPTY_STATE.TITLE')"
    :subtitle="$t('CAPTAIN.TOOLS.EMPTY_STATE.SUBTITLE')"
    :action-perms="['administrator']"
  >
    <template #empty-state-item>
      <div class="grid grid-cols-1 gap-4 p-px overflow-hidden">
        <ToolCard
          v-for="(tool, index) in sampleTools"
          :id="tool.id"
          :key="`tool-${index}`"
          :name="tool.name"
          :title="tool.title"
          :description="tool.description"
          :assistant="tool.assistant"
          :api-spec="tool.api_spec"
          :enabled="tool.enabled"
          :created-at="tool.created_at"
        />
      </div>
    </template>
    <template #actions>
      <Button
        :label="$t('CAPTAIN.TOOLS.ADD_NEW')"
        icon="i-lucide-plus"
        @click="onClick"
      />
    </template>
  </EmptyStateLayout>
</template>
